<template>
  <div class="participants">
    <h3>参加者一覧</h3>
    <hr>
    <br>

    <table><tbody>
      <tr>
        <th>氏名</th>
        <th>所属</th>
        <th>身分</th>
      </tr>
      <tr v-for="(participant, idx) in db_participants" :key="idx">
          <td>{{ participant.name }}</td>
          <td>{{ participant.belong }}</td>
          <td>{{ participant.position }}</td>
      </tr>
    </tbody></table>

    <hr>
  </div>
</template>

<script>
import { db } from '../main'

export default {
  name: 'Participants',
  data () {
    return {
      db_participants: null
    }
  },
  firestore () {
    return {
      db_participants: db.collection('participants').orderBy('datetime')
    }
  }
}
</script>

<style>

.participants table {
  border-collapse: collapse;
  border: solid 3px rgb(34,110,147);
  table-layout: fixed;
  width: 100%;
}
.participants table th, table td {
  border: dashed 1px rgb(101, 101, 101);
  padding: 10px;
  text-align: center;
}
.participants table th {
  background-color:rgb(34,110,147);
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Participants.vue